import { Component, Vue } from 'vue-property-decorator';
import lerCodeModule from '@/store/modules/ler-code.module'
import { LerCode } from '@/shared/dtos/ler-code';
import DxDataGrid, { DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';



@Component({
    components: {
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser
    },
})

export default class LerLista extends Vue {

    public pageSize: number = 15;
    public maxWidth: number = 500;
    public addHidden = true;
    public loading = false;
    public search = '';
    public lerCode: LerCode = new LerCode();

    public get lerCodeList() {
        return lerCodeModule.lerCodes;
    }

    public get columns() {
        return [
            { dataField: 'id', allowEditing: false },
            { dataField: 'code', caption: this.$tc('maestro-configuracion.codigo'), allowEditing: true },
            { dataField: 'description', caption: this.$tc('maestro-configuracion.descripcion'), allowEditing: true},
        ]
    }

    public mounted() {
        lerCodeModule.getLerCodes();
    }

    public rowInserted(e: any){
        lerCodeModule.insertarLerCode(e.data);
    }

    public rowUpdated(e: any){
        lerCodeModule.modificarLerCode(e.data);
    }
    
    public rowRemoved(e: any){
        lerCodeModule.eliminarLerCode(e.key);
    }

    public initNewRow(e: any){
        e.data.id = 0;
    }
}